const firebaseConfig = {
    apiKey: "AIzaSyAFtFYOD1pPtwSrfxzzX4lybyTfM2he3mY",
    authDomain: "adhd-prototype.firebaseapp.com",
    projectId: "adhd-prototype",
    storageBucket: "adhd-prototype.appspot.com",
    messagingSenderId: "677433061194",
    appId: "1:677433061194:web:a8564698cf520107519bb3",
    measurementId: "G-5F279PRTVB"
};


export default firebaseConfig
